import React from 'react';

interface RYITankyouMessageProps {
  message: string;
}
const RYITankyouMessage: React.FC<RYITankyouMessageProps> = ({ message }) => {
  return (
    <div className="prelaunch">
      <div
        className="pageSection__content"
        id="competitionSuccess"
        data-content="competitionSuccessContent"
      >
        <div className="row">
          <div className="col-xs-12 col-md-8 col-lg-6 col-md-offset-2 col-lg-offset-3">
            <h1 className="h1 text-center font-boxx">Thank You!</h1>
            <p className="text-center">
              <label
                className="fieldLabel"
                htmlFor="terms"
                dangerouslySetInnerHTML={{ __html: message }}
              />
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RYITankyouMessage;
